var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEraserTool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.118,
    y: 3.645,
    width: 13.354,
    height: 23.281,
    rx: 2,
    transform: "rotate(45 20.118 3.645)",
    fill: "url(#eraser-tool_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.072 12.69l9.443 9.443-1.372 1.372L9.7 14.063z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eraser-tool_svg__paint0_linear",
    x1: 26.795,
    y1: 3.645,
    x2: 26.795,
    y2: 26.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FF2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A2A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserTool);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzMgMzMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjIwLjExODMiIHk9IjMuNjQ0NTUiIHdpZHRoPSIxMy4zNTQiIGhlaWdodD0iMjMuMjgwOCIgcng9IjIiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDIwLjExODMgMy42NDQ1NSkiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHJlY3QgeD0iMTEuMDcyMiIgeT0iMTIuNjkwNyIgd2lkdGg9IjEzLjM1NCIgaGVpZ2h0PSIxLjk0MDA1IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMS4wNzIyIDEyLjY5MDcpIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMjYuNzk1MyIgeTE9IjMuNjQ0NTUiIHgyPSIyNi43OTUzIiB5Mj0iMjYuOTI1MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDA5OUZGIi8+CjxzdG9wIG9mZnNldD0iMC41NzI5MTciIHN0b3AtY29sb3I9IiMwMDk5RkYiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyNSIgc3RvcC1jb2xvcj0iI0ZGMkEyQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjJBMkEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };